import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [schema, setSchema] = useState('');
  const [loginResult, setLoginResult] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=login&schema=${encodeURIComponent(schema)}&tuser=${username}&tpass=${password}`
      );
      const data = await response.json();
      if (data[0].TUSERNAME !== "SALAH") {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('nama_user', data[0].TUSERNAME);
        localStorage.setItem('id_user', data[0].ID_USER);
        localStorage.setItem('is_admin', data[0].IS_ADMIN);
        localStorage.setItem('po_access', data[0].PO);
        localStorage.setItem('do_access', data[0].DO);
        localStorage.setItem('ts_access', data[0].TS);
        localStorage.setItem('ppo_access', data[0].PPO);
        localStorage.setItem('bk_access', data[0].BK);
        localStorage.setItem('hk_access', data[0].HK);
        localStorage.setItem('sj_access', data[0].SJ);
        localStorage.setItem('mobilfree_access', data[0].MOBILFREE);
        localStorage.setItem('lap_hk_access', data[0].LAP_HK);
        localStorage.setItem('lap_sj_access', data[0].LAP_SJ);
        localStorage.setItem('LastPosition', data[0].LASTPOSITION);
        localStorage.setItem('lap_daily', data[0].IS_ADMIN);
        localStorage.setItem('lap_mg_access', data[0].LAP_MG);
        localStorage.setItem('lap_jbm_access', data[0].LAP_JBM);
        localStorage.setItem('mi_access', data[0].MI);
        localStorage.setItem('lap_kinerja_access', data[0].LAP_KINERJA);
        localStorage.setItem('schema', schema);
        navigate('/dashboard', { state: { tusername: data[0].TUSERNAME } });
      } else {
        setLoginResult('Login gagal, username atau password salah');
      }
    } catch (error) {
      console.error('Error:', error);
      setLoginResult('Login gagal, silakan coba lagi');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className="App">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon">T</div>
          <h1 className="login-title">PTKMT</h1>
          <p className="login-subtitle">Sistem Manajemen Operasional</p>
        </div>

        <form onSubmit={(e) => e.preventDefault()}>
          <div className="input-group">
            <label className="input-label">Username</label>
            <input
              type="text"
              placeholder="Masukkan username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="username"
            />
          </div>

          <div className="input-group">
            <label className="input-label">Password</label>
            <input
              type="password"
              placeholder="Masukkan password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="current-password"
            />
          </div>

          <div className="input-group">
            <label className="input-label">Server</label>
            <input
              type="text"
              placeholder="Nama server / schema"
              value={schema}
              onChange={(e) => setSchema(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <button type="button" className="login-btn" onClick={handleLogin}>
            Masuk
          </button>
        </form>

        {loginResult && <p className="error" style={{ marginTop: 12 }}>{loginResult}</p>}
      </div>
    </div>
  );
}

export default LoginPage;
